import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Button = ({ children, className, tag, theme, ...rest }) => {
  const Tag = tag === 'button' ? 'button' : 'a';
  const themeClass = theme ? `button--${theme}` : '';

  return (
    <Tag
      className={classnames('button', { [themeClass]: themeClass }, { [className]: className })}
      {...rest}
    >
      {children}
    </Tag>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  tag: PropTypes.string,
  theme: PropTypes.string,
};

export default Button;
